{
  "title": "Entidades no individuales",
  "entityType": "Tipo de entidad",
  "typeOfTrust": "Tipo de fideicomiso",
  "natureOfBusiness": "Naturaleza del negocio",
  "entityName": "Nombre de la entidad",
  "createNewNonIndividualEntity": "Crear nueva entidad no individual",
  "relationships": "Relaciones",
  "noRelationship": "No hay relaciones actualmente",
  "table": {
    "name": "Nombre",
    "primaryContact": "Contacto principal",
    "suitabilityScore": "Puntuación de idoneidad",
    "notCompleted": "Sin completar",
    "completedAt": "Completado en",
    "noOfAccounts": "# de cuentas",
    "totalAssets": "Total de activos",
    "entityType": "Tipo de entidad",
    "organization": "Organización"
  },
  "editRelationship": "Editar relación",
  "addRelationship": "Agregar relación nueva",
  "deleteRelationship": "Eliminar relación",
  "selectExistingUsers": "Seleccionar usuarios existentes",
  "createNewUser": "Crear nuevo usuario",
  "edit": {
    "relationshipTo": "Relación con {{whom}}"
  },
  "remove": {
    "areYouSure": "¿Está seguro que desea eliminar a {{removedWhoName}}?",
    "thisWillNotDelete": "Esto no borrará la información de {{removedWhoName}}, solo dejará de estar asociado con {{removedFromName}}.",
    "yesRemove": "Sí, eliminar",
    "hasBeenRemoved": "El cliente ha sido eliminado de la lista de entidades relacionadas"
  }
}
